<template>
    <div id="dashboardBillingSection">
        <section id="StudentBalance" class="account-balance card">
            <h2 id="account-header" class="card-header">
                <a id="balanceanchor" name="balanceanchor"></a>
                <button class="btn btn-link" data-toggle="collapse" aria-label="Toggle Account Balance Section (Mobile View)" data-target=".account-card-body" aria-expanded="true" aria-controls="account-card-body" @click="collapsePanel">
                    <span class="icon icon-dollar"></span>Account Balance
                </button>
            </h2>
            <div v-if="balanceIsLoaded == 1" class="account-card-body card-body collapse" aria-labelledby="account-header">
                <div>
                    <p>You owe <span class="balance-number">{{balance | toCurrency}}</span></p>
                    <p><a :href="selfServiceAccountPath" target="_blank">
                        View Account Balance Details
                        </a>
                    </p>
                </div>
            </div>
            <div v-else class="account-card-body card-body collapse" aria-labelledby="account-header">
                <div v-if="balanceIsLoaded == 2">
                    <p>We are having trouble loading this section. This could be because we can't find a record for you or we are having connectivity problems.</p>
                </div>
                <div v-else>
                    <spinner></spinner>
                </div>
            </div>  
        </section>
        <section id="StudentHolds" class="student-holds card" v-if="notNullOrEmpty(holds)">
            <h2 id="holds-header" class="card-header">
                <a id="holdsanchor" name="holdsanchor"></a>
                <button class="btn btn-link" data-toggle="collapse" aria-label="Toggle Holds Section (Mobile View)" data-target=".holds-card-body" aria-expanded="true" aria-controls="holds-card-body" @click="collapsePanel">
                    <span class="icon icon-attention"></span>Holds
                </button>
            </h2>
            <div class="holds-card-body card-body collapse" aria-labelledby="holds-header">
                <p>A hold may be placed on your record for many reasons and can prevent you from registering, receiving your grades and transcripts, and more.</p>
                <div v-for="(item, index) in holds" :key="index">
                    <div class="hold block">
                        <p class="mb-0"><strong>Hold Type:</strong> {{item.holdType.description}}</p>
                        <p class="mb-0"><strong>Reason:</strong> {{item.holdReason.description}}</p>
                        <p class="mb-0"><strong>Prevents:</strong> {{notNullOrEmpty(item.holdType.prevents)? item.holdType.prevents : "N/A"}}</p>
                    </div>
                </div>
            </div>
        </section>
        <section id="StudentFinAid" class="financial-aid card" v-if="notNullOrEmpty(finAidObjs)">
            <h2 id="aid-header" class="card-header">
                <a id="finaidanchor" name="finaidanchor"></a>
                <button class="btn btn-link" data-toggle="collapse" aria-label="Toggle Financial Aid Section (Mobile View)" data-target=".aid-card-body" aria-expanded="true" aria-controls="aid-card-body" @click="collapsePanel">
                    <span class="icon icon-bank"></span>Financial Aid
                </button>
            </h2>
            <div class="aid-card-body card-body collapse" aria-labelledby="aid-header">
                <div v-for="(item, index) in finAidObjs" :key="index">
                    <div class="block">
                        <p v-if="notNullOrEmpty(item.fafsaReceived)"><span v-html="item.fafsaReceived"></span></p>
                        <p v-if="notNullOrEmpty(item.letterAvailable)"><span v-html="item.letterAvailable"></span></p>
                    </div>
                </div>
                <div class="block block-bottom">
                    <p><a href="http://osfa.illinois.edu">Visit Financial Aid's website</a></p>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import spinner from "../components/spinner.vue"
    import { getSelfServiceAccountUrl } from "@/common/envMixins";
    export default {
        name: 'StudentBalance',
        components: {spinner},
        computed: {
            balanceIsLoaded() { return this.$store.state.balanceIsLoaded },
            balance() { 
                return this.$store.state.balanceAndHolds.balance; 
            },
            holds () {
                return this.$store.state.balanceAndHolds.holds;
            },
            finAidObjs () {
                return this.$store.state.balanceAndHolds.finAidObjs;
                
            },
            selfServiceAccountPath() { return getSelfServiceAccountUrl() }

        },
        mounted() {
            if (this.$store.state.balanceIsLoaded == 0) {
                this.$store.dispatch("getBalanceAndHolds");
            }
        }
        
    };
</script>